import {hourToAMPM} from "../../utils/hourToAMPM";
import {BlackoutDateProps, DAY} from "../../types/BlackoutPeriod";
import BlackoutPeriodHour from "./BlackoutPeriodHour";
import {useContext, useState} from "react";
import {BlackoutPeriodContext} from "./BlackoutPeriods";
import useAppContext from "../../hooks/useAppContext";
import {BLACKOUT_PERIODS_COLORS} from "../charts/consts/COLOR_SETS";

interface BlackoutPeriodDayProps {
    day: DAY,
    dayPeriods: BlackoutDateProps[];
}

const BlackoutPeriodDay = ({ day, dayPeriods }: BlackoutPeriodDayProps) => {

    const getBlackoutPeriod = (hour: number) =>
        dayPeriods.filter((dayPeriod: BlackoutDateProps) => {
                if(dayPeriod.fromDay && dayPeriod.toDay) {
                    const { fromDay, toDay, fromTime, toTime } = dayPeriod;
                    return (
                        //same day, between hours
                        day === fromDay && day === toDay && fromTime === hour
                    ) || (
                        //started today before this hour, ends tomorrow
                        day === fromDay && day < toDay && hour === fromTime
                    ) || (
                        //between 2 days when toDay is bigger than fromDay
                        day > fromDay && day < toDay && hour === 0
                    ) || (
                        //Started in any previous day, and will end today in later hour
                        day !== fromDay && day === toDay && toTime > hour && hour === 0
                    ) || (
                        //Started in any previous day, and gonna end next week
                        day > fromDay && day > toDay && fromDay > toDay && hour === 0
                    ) || (
                        //Started today, and gonna end next week
                        day === fromDay && day > toDay && fromDay > toDay && hour === fromTime
                    );
                }
            }
        );

    return (
        <div className="day">
            {[...new Array(24)].map((hourOfDay, index) => {
                const blackoutPeriods = getBlackoutPeriod(index);
                return (
                    <BlackoutPeriodHour key={`day-${day}-${index}`}
                        day={day}
                        hour={index}
                        blackoutPeriods={blackoutPeriods}
                    />
                );
            })}
        </div>
    );
}

export default BlackoutPeriodDay;